export const SSO_METRICS = {
  LOGIN_ATTEMPT:                    'SSO Login Attempted',
  LOGIN_ATTEMPT_WITH_ACTIVATION:    'SSO Login Attempt with Activation',
  LOGIN_FAILED:                     'SSO Login Failed',
  LOGIN_JTI_ALREADY_USED:           'SSO Login with Already used JTI',
  USER_CANCELLED_LOGIN:             'SSO User Cancelled Login Request',
  INVALID_GRANT:                    'SSO Invalid Grant',
  MISSING_CODE_VERIFIER:            'SSO Missing Code Verifier',
  INCOMPLETE_CALLBACK:              'SSO Incomplete Callback Missing Code Or State',
  NO_PROFILE_FOR_TOKEN:             'SSO Profile Service Returned No Profile',

  // Login success is different from completed
  // Completed verifies that the user is headed to their final redirection page
  // after possibly going through the VPPA flow. Not just having valid tokens.
  LOGIN_SUCCESS:                    'SSO Login Successful',
  LOGIN_COMPLETED:                  'SSO Login Completed',

  LOGOUT_ATTEMPT:                   'SSO Logout Attempted',
  LOGOUT_SUCCESS:                   'SSO Logout Succeeded',
  PROFILE_TOKEN_FORCED_LOGOUT:      'SSO Session Profile Not Refreshable',
  PROFILE_TOKEN_REJECTED:           'SSO Session Profile Refresh Token Rejected',
  PROFILE_ERROR:                    'SSO Session Profile Error',
  PROFILE_LINK_REDIRECT:            'Sending User To Profile Page',
  REGISTER_ATTEMPT:                 'SSO Registration Attempted',
  REGISTER_ATTEMPT_WITH_ACTIVATION: 'SSO Registration Attempt with Activation',

  // Session diagnostics
  SESSION_NO_COOKIE:                'SSO Session Cookie Missing',
  SESSION_CACHE_MISS:               'SSO Session Cache Miss',
  SESSION_CACHE_NULL_DATA:          'SSO Session Cache Returned Null Data',
  SESSION_CACHE_PARSE_ERROR:        'SSO Session Cache JSON Parse Error',

  // Token diagnostics
  GET_USER_NO_TOKEN_INFO:           'SSO GetUser No TokenInfo In Session',
  GET_USER_NO_ACCESS_TOKEN:         'SSO GetUser TokenInfo Missing AccessToken',
  GET_USER_SUCCESS:                 'SSO GetUser Success',
  TOKEN_REFRESH_ATTEMPT:            'SSO Token Refresh Attempt',
  TOKEN_REFRESH_SUCCESS:            'SSO Token Refresh Success',
  TOKEN_REFRESH_FAILED:             'SSO Token Refresh Failed',
  TOKEN_REFRESH_IN_PROGRESS:        'SSO Token Refresh Already In Progress',
  TOKEN_MISSING_REFRESH_TOKEN:      'SSO Token Missing Refresh Token',

  // Profile service diagnostics
  PROFILE_SERVICE_FETCH_ATTEMPT:    'SSO Profile Service Fetch Attempt',
  PROFILE_SERVICE_FETCH_SUCCESS:    'SSO Profile Service Fetch Success',
  PROFILE_SERVICE_FETCH_FAILED:     'SSO Profile Service Fetch Failed',
  PROFILE_SERVICE_NON_OK_RESPONSE:  'SSO Profile Service Non-OK Response',
  PROFILE_SERVICE_NO_PROFILE:       'SSO Profile Service Returned No Profile Data',

  // Content service diagnostics
  CS_FETCH_FAILED:                  'SSO Content Service Fetch Failed',
  CS_FETCH_NON_OK_RESPONSE:        'SSO Content Service Non-OK Response',

  // Profile route diagnostics
  // A route was given a uid by the client that disagrees with the session's.
  // Recorded while the [uid] path segments are still accepted, so the cohort can
  // be sized before they are removed.
  CLIENT_UID_MISMATCH:              'SSO Client Supplied UID Disagrees With Session',

  PROFILE_ROUTE_NULL_USER:          'SSO Profile Route User Is Null',
  PROFILE_ROUTE_NULL_PROFILE:       'SSO Profile Route Profile Is Null',
  PROFILE_ROUTE_SUCCESS:            'SSO Profile Route Success',
}

export const PASSPORT_ACTIVATION_METRICS = {
  NAMESPACE:                        'passport:activation',
  ATTEMPT:                          'Attempt',
  FAILURE_ACTIVATION_FAILED:        'Failure - activation failed error',
  FAILURE_DATA_MISSING:             'Failure - activated data missing',
  FAILURE_MEMBERSHIP_ACTIVE:        'Failure - membership already active',
  FAILURE_MEMBERSHIP_CHECK:         'Failure - membership check error',
  FAILURE_MISSING_MEMBERSHIP_ID:    'Failure - missing membership id error',
  FAILURE_MISSING_USER_DATA:        'Failure - missing user data error',
  FAILURE_MISSING_USER_DATA_STATION_ID:    'Failure - missing user data error: station id',
  FAILURE_MISSING_USER_DATA_MEMBERSHIP_PK: 'Failure - missing user data error: membership pk',
  FAILURE_MISSING_USER_DATA_CALLSIGN:      'Failure - missing user data error: callsign',
  FAILURE_MISSING_USER_DATA_SIGNEDINEMAIL: 'Failure - missing user data error: signed in email',
  FAILURE_NO_PROFILE:               'Failure - no profile error',
  FAILURE_PROFILE_ERROR:            'Failure - profile load error',
  FAILURE_PROFILE_TIMEOUT:          'Failure - profile status never resolved',
  SUCCESS:                          'Success!',
}

export const REPORT_A_PROBLEM_METRICS = {
  NAMESPACE:                        'video:report_a_problem',
  PROBLEM_SUBMITTED:                'Video Problem Submitted',
}

export const CLIENT_PROFILE_METRICS = {
  NAMESPACE: 'profile:changes',
  LOCALIZATION_PREFETCH_MISMATCH: 'Prefetching Mismatch Between Server Station ID and Localized Station ID',
  STATION_FORCED_RELOAD: 'Localization Change Forced Reload',
  USER_CHANGED_STATION: 'User Manually Changed Stations',
  POLL_FORCED_RELOAD: 'Poll Station Mismatch Forced Reload',
  POLL_PROFILE_WIPED: 'Poll Error Wiped Profile',
  POLL_SERVER_ERROR_PRESERVED: 'Poll Server Error Preserved Profile',
  POLL_NO_UID_PROFILE_CLEARED: 'No UID Cookie Profile Cleared',
}

export const APP_SIGN_IN_METRICS = {
  NAMESPACE:                        'app_sign_in',
  ATTEMPT:                          'Attempt',
  FAILURE_ACTIVATION_ERROR:         'Failure - device activation error',
  FAILURE_CODE_ERROR:               'Failure - code error',
  FAILURE_CODE_EXPIRED:             'Failure - code expired',
  SUCCESS:                          'Success!',
}

export const PASSPORT_TRANSFER_METRICS = {
  NAMESPACE:                        'passport:transfer',
  ATTEMPT:                          'Attempt',
  FAILURE_ACTIVATION_FAILED:        'Failure - transfer activation failed error',
  FAILURE_DATA_MISSING:             'Failure - transfer data missing',
  SUCCESS:                          'Success!',
}

export const LOCALIZATION_VERIFICATION_METRICS = {
  NAMESPACE:                        'localization_verification',
  ATTEMPT:                          'Attempt',
  FAILURE_TOKEN_USED:               'Failure - token is already used',
  FAILURE_ERROR_FROM_API:           'Failure - error from API (such as invalid token)',
  FAILURE_ERROR:                    'Failure - error (something went wrong)',
  SUCCESS_AUTHORIZED:               'Success! User is authorized',
  SUCCESS_UNAUTHORIZED:             'Success! But user is unauthorized',
}

export const INTERNAL_ROUTE_METRICS = {
  QUEUE_CLEAN_BATCH_ATTEMPT:        'Attempting to clean queue batch',
  QUEUE_CLEAN_BATCH_COMPLETED:      'Completed cleaning queue batch'
}
